<template>
    <div>
        <p class="listLength">共计 <span>{{Total}}条</span></p>
        <LoadingFooter :finished="finished" v-model='loading' @load="onLoad" @scroll="$Bus.$emit('IsSee',false);">
            <div style="padding-top: 8vw;">
                <div class="items" v-for="item in list" @click="pageLoad(item)">
                    <div>
                        <img src="@/assets/img/Icon_1.png" />
                        <div>
                            <p class="ellipsis">{{item.HTMC}}</p>
                            <div>
                                <div>
                                    <p>设备名称：</p>
                                    <p>单价：</p>
                                    <p>数量：</p>
                                    <p>合同金额：</p>
                                    <p>乙方单位：</p>
                                </div>
                                <div>
                                    <p class="ellipsis">{{item.MC}}</p>
                                    <p class="ellipsis">{{item.DJ}}</p>
                                    <p class="ellipsis">{{item.SL}}</p>
                                    <p class="ellipsis">¥{{item.HTJE}}</p>
                                    <p class="ellipsis">{{item.GYSMC}}</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src="../../assets/img/right.png" />
                            </div>
                            <div>验收</div>
                        </div>
                    </div>
                    <div>
                        <span>合同编号</span>
                        <span>{{item.HTBH}}</span>
                    </div>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" v-if="IsSee">
                <Field title="合同编号" placeholder="请输入合同编号" :text='search.HTMC' @onMessage="value => search.HTMC = value" />
                <Field title="供应商" placeholder="请输入供应商" :text='search.GYSMC' @onMessage="value => search.GYSMC = value" />
                <Field title="设备名称" placeholder="请输入设备名称" :text='search.SBMC' @onMessage="value => search.SBMC = value" />
                <Field title="开始时间" placeholder="请选择" type="calendar" :text='search.StartDate' @onMessage="value => search.StartDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" :text='search.EndDate' @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition>
    </div>
</template>
<script>
    import {
        AcceptanceOfTheJump
    } from '../../../tool/api/StorageInspection.js'
    import Field from '../field/field'
    import LoadingFooter from '../loadingFooter/loadingFooter'
    export default {
        name: 'CheckAndAccept',
        components: {
            Field,
            LoadingFooter
        },
        props: {
            IsSee: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                list: [],
                search: {
                    HTMC: null,
                    GYSMC: null,
                    SBMC: null,
                    StartDate: null,
                    EndDate: null
                },
                loading: true,
                finished: false,
                Total: 0, //共计条数
                PageIndex: 1,
                Button: false,
            }
        },
        mounted(){
            this.list=[];
            this.loadDataDefault();
        },
        methods: {
            loadDataDefault() { //加载默认数据
                this.$post('api/CheckIncoming/AcceptanceList', {
                    PageIndex: this.PageIndex,
                    PageSize: 10,
                    StartTime: this.search.StartDate,
                    EndTime: this.search.EndDate,
                    HTMC: this.search.HTMC,
                    GYSMC: this.search.GYSMC,
                    SBMC: this.search.SBMC,
                    Store: this.$UserInfo.StoreCode,
                    GKHM:this.$UserInfo.UserId,
                    Token: ''
                }).then(result => {
                    this.Total = result.Total;
                    var that = this;
                    result.AcceptanceList.map((item) => {
                        that.list.push(item);
                    });
                    if (this.PageIndex * 10 >= result.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            },
            serach() { //查询事件
                this.list = [];
                this.PageIndex = 1;
                this.$Bus.$emit('IsSee', false);
                this.loadDataDefault();
            },
            onLoad() { //下拉事件
                if (!this.finished && !this.loading) {
                    this.loading = true;
                    this.PageIndex += 1;
                    this.loadDataDefault();
                }
            },
            pageLoad(item) { //验收跳转操作
                AcceptanceOfTheJump(item);
            }
        },
        watch: {
            $route(to,from){
                if(from.name=='EquipmentAcceptanceDetails'){
                    this.PageIndex=1;
                    this.list=[];
                    this.loadDataDefault();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-top: 12vw;
        margin-bottom: 20px;
        transition: all .5s;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;

                        &>p {
                            color: $TEXT-DARK-COLOR;
                            font-weight: bold;
                            font-size: 32px;
                            margin-bottom: 18px;
                            width: 350px;
                        }

                        &>div {
                            display: flex;

                            p {
                                color: #999;
                                font-size: 26px;
                                line-height: 45px;
                                height: 45px;
                                width: 150px;
                            }

                            &>div {
                                &:last-child {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }
                    }

                    &:last-child {
                        &>div {
                            &:first-child {
                                color: $TEXT-DARK-COLOR;
                                font-size: 32px;
                                display: flex;
                                justify-content: flex-end;
                                align-items: center;

                                span:first-child {
                                    margin-left: 10px;
                                    font-size: 20px;
                                    width: 100px;
                                    text-align: right;

                                    span {
                                        margin-left: 5px;
                                        font-size: 32px;
                                    }
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                }
                            }

                            &:last-child {
                                width: 152px;
                                height: 61px;
                                background: $THEME-COLOR;
                                border-radius: 30px;
                                text-align: center;
                                line-height: 61px;
                                font-size: 26px;
                                color: $TEXT-LIGHT-COLOR;
                                margin-top: 62px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .listLength {
        top: 25vw !important;
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: -580px;
        margin-left: 30px;
        transition: all .5s;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/StorageInspection/CheckAndAccept.vue